/*
Example state:

export default {
  data: [
    {
      id: 'ans1',
      name: 'Can you guess who is NOT cool?',
      content: {
        public: {
          bodyHtml: '<span>Jdom is not cool.</span>',
        },
      },
    },
   {
    id: 'ans2',
    name: 'Can you guess who IS cool?',
    content: {
      public: {
        bodyHtml: '<span>Kaylee is cool.</span>',
      },
    },
  ],
  suggestedAnswerIds: ['ans1', 'ans2'],
  searchResultAnswerIds: ['ans1', 'ans2'],
  selectedResultAnswerId: '',
};

*/

export default {
  data: [],
  suggestedAnswerIds: [],
  searchResultAnswerIds: [],
  selectedResultAnswerId: '',
};
